// Système d'internationalisation

export interface I18nStrings {
  cardTitle: (num: number, side: 'front' | 'back') => string;
  insertFlipCard: string,
  frontSide: string;
  backSide: string;
  flipToBack: string;
  flipToFront: string;
  clickToFlip: string;
  addText: string;
  addTextPlaceholder: string;
  addImage: string;
  insertImage: string;
  uploadFile: string;
  urlPlaceholder: string;
  ok: string;
  cancel: string;
  copyCard: string;
  deleteCard: string;
  resetFace: string;
  dragHandle: string;
  or: string;
}

import {en} from './en';
import {fr} from './fr';
import {es} from './es';
import {de} from './de';

const translations: Record<string, I18nStrings> = {
  en,
  fr,
  es,
  de
};

export function getTranslations(locale: string = 'en'): I18nStrings {
  return translations[locale] || translations.en;
}

export { en, fr, es, de};
